import axios, { BUSINESS_PAYMENT_PREFIX } from 'src/clients/axios';
import type {
  EcardListResponse,
  PostInquiryParams,
  PostInquiryResponse,
} from 'src/models';
import {
  BankAccountGetRsData,
  BankAccountInquiryCountGetRsData,
  BankAccountPostRqData,
  BankAccountPostRsData,
} from 'src/models/Client';

export function getEcardList() {
  return axios.request<EcardListResponse>({
    url: `${BUSINESS_PAYMENT_PREFIX}/account/bank-account/list`,
    method: 'get',
  });
}

export function postInquiry(data: PostInquiryParams) {
  return axios.request<PostInquiryResponse>({
    url: `${BUSINESS_PAYMENT_PREFIX}/account/bank-account/inquiry`,
    method: 'post',
    data: {
      account_number: data.account_number,
      bank_code: data.bank_code,
      use_limitation: data.use_limitation || true,
      virtual_account_allowed: data.virtual_account_allowed || false,
    },
  });
}

export function getCountInquiry() {
  return axios.get<BankAccountInquiryCountGetRsData>(
    `${BUSINESS_PAYMENT_PREFIX}/account/bank-account/inquiry/count`,
  );
}

export function getBankAccount() {
  return axios.get<BankAccountGetRsData>(
    `${BUSINESS_PAYMENT_PREFIX}/account/bank-account`,
  );
}

export function saveBankAccount(data: BankAccountPostRqData) {
  return axios.post<BankAccountPostRsData>(
    `${BUSINESS_PAYMENT_PREFIX}/account/bank-account`,
    data,
  );
}
